import React from 'react';
import './VotingResult.scss';

function VotingResult({ total, text, users = [] }) {
    let fraction = 0;
    if (total > 0) {
        fraction = (100 * users.length) / total;
    }
    if (fraction % 1) {
        fraction = fraction.toFixed(1);
    }

    const selected =
        users.length && window.userId && users.indexOf(window.userId) !== -1;

    return (
        <div
            className={`voting-result ${selected ? 'selected' : ''}`}
            title={selected ? 'Вы выбрали этот вариант' : ''}
        >
            <div className='voting-result__text'>
                {total > 0 ? (
                    <span className='fraction'>{fraction} ({users.length} чел.)%</span>
                ) : null}

                <span className='text'>{text}</span>
            </div>

            <div
                className='voting-result__line'
                style={{ width: `${fraction}%` }}
            ></div>
        </div>
    );
}

export default VotingResult;
